import { currency } from "./currency";

export default {
    formatCurrency(formatter, value) {
        let formattedPrice = formatter.format(value);        

        if (currency === "DKK") {
            return formattedPrice = formattedPrice.substring(0, formattedPrice.length - 1).replace(".", " ");            
        }
        
        return formattedPrice;
    },
}